import { render, staticRenderFns } from "./OpsGenieIntegration.vue?vue&type=template&id=51b36043&"
import script from "./OpsGenieIntegration.vue?vue&type=script&lang=ts&"
export * from "./OpsGenieIntegration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports